import { Button } from "@shopify/polaris"
import { XIcon } from "@shopify/polaris-icons"
import classNames from "classnames"
import { CSSProperties, MouseEventHandler } from "react"
import { Link, LinkProps } from "react-router-dom"

import styles from "./ImageBanner.module.scss"

export interface Props {
  show: boolean;// 是否显示
  src: string;// 图片地址
  minHeight?: "large" | "medium" | "normal";// 最小高度设置
  alt?: string;
  style?: CSSProperties
  to?: LinkProps["to"];
  target?: LinkProps["target"];
  children?: React.ReactNode
  onClose?(): void;// 关闭回调，如果有这个回调，那么就可以关闭
  onLinkClick?: MouseEventHandler<HTMLAnchorElement>
  onClick?(): void
}

export const MarketingPicture = ({ show, to, onClose, src, alt, style, onLinkClick, children, minHeight = "normal", onClick }: Props) => {
  const imgMarkUp = <img className={styles.Img} src={src} alt={alt} />

  const handleCloseBanner = () => {
    typeof onClose === "function" && onClose()
  }

  return show ? <div className={classNames(styles.ImageBanner, styles[minHeight])} style={{ ...style, ...(onClick ? { cursor: "pointer" } : {}) }} onClick={onClick}>
    {onClose && <div className={styles.CloseButton}>
      <Button onClick={handleCloseBanner} icon={XIcon} variant="plain" />
    </div>}
    {children}
    {to ? <Link to={to} onClick={onLinkClick}>{imgMarkUp}</Link> : imgMarkUp}
  </div> : null
}
